import React, { Component } from 'react';
import Button from '@mui/material/Button';
import MainStore from '../../../MainStore';
import AuthStore from '../../Auth/AuthStore'
import UserSelect from '../Users/UserSelect';
import UserAvatar from '../Users/UserAvatar';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

export default class Participants extends Component {
    constructor(props) {
        super(props);

        this.state = {
            participants: []
        };

        this.addParticipant = this.addParticipant.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.load = this.load.bind(this);
        this.deleteParticipant = this.deleteParticipant.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.projectId !== this.props.projectId) {
            this.load();
        }
    }

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        fetch('api/Project/Participants?id=' + (this.props.projectId ? this.props.projectId : ''), {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ participants: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    addParticipant() {
        if (!this.state.user) {
            return;
        }
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Project/AddParticipant', {
            method: 'POST',
            body: JSON.stringify({ projectId: this.props.projectId, userId: this.state.user.id }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    if (result.isExists) {
                        alert("Участник уже добавлен");
                        return;
                    }
                    var participants = scope.state.participants.slice(0);
                    participants.push({ name: scope.state.user.name, userId: scope.state.user.id });
                    scope.setState({ participants: participants });
                }).catch((err) => console.log(err));
            }
        });
        
    }

    deleteParticipant(userId) {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Project/DeleteParticipant', {
            method: 'POST',
            body: JSON.stringify({ projectId: this.props.projectId, userId: userId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    if (result.isExists) {
                        alert("Участник уже добавлен");
                        return;
                    }
                    var participants = scope.state.participants.slice(0);
                    participants.splice(participants.findIndex(p => p.userId === userId), 1);
                    scope.setState({ participants: participants });
                }).catch((err) => console.log(err));
            }
        });

    }

    handleSelect(user) {
        this.setState({ user: user });
    }

    render() {
        if (!this.props) {
            return <div></div>
        }

        var participants = this.state.participants && this.state.participants.map(p => <div className="participant-block clearfix">
            <div className="participant-cell">
                <UserAvatar userId={p.userId} />
            </div>
            <div className="participant-cell">
                {p.name}
            </div>
            <div className="participant-cell">
                <IconButton onClick={() => { this.deleteParticipant(p.userId); }} size="large">
                    <DeleteIcon />
                </IconButton>
            </div>
            </div>);

    return (
        <div>
            <UserSelect handleSelect={this.handleSelect}/>
            <Button onClick={this.addParticipant} color="primary">
                Добавить
            </Button>
            <div className="clearfix">
                {participants}
            </div>
        </div>
    );
    }
}
